@if (file$ | async; as file) {
  <icz-transactions
    [type]="TransactionHistoryType.ENTITY"
    [entityId]="file.id"
    [esslObjectType]="EsslObjectType.FILE"
    [identifier]="file.uid?.identifier"
    [idSource]="file.uid?.idSource"
    class="grow"
  ></icz-transactions>
}
